// Trigger-question types for the report builder (decision 2026-06-04 in
// docs/ramdocs-user-input-model-from-rams-app.md): a short set of job-specific
// questions whose answers change document content — hazard modules in/out,
// permits added/removed, competence/substances/emergency/sequence content,
// job-specific scope notes, readiness checks. Follow-up (Layer-2) questions are
// revealed by their parent answer. The full hazard list stays available behind
// "Advanced".

export type TriggerQuestion = {
  key: string;
  label: string;
  kind: "yesno" | "choice" | "text";
  /** For kind=choice. */
  options?: string[];
  /** For kind=text: placeholder + readiness check that fails while empty. */
  placeholder?: string;
  requiredCheck?: string;
  /** Effects keyed by answer ("yes"/"no" or a choice option). Text answers use "*". */
  effects?: Record<string, TriggerEffect>;
  /** Adds a "Not sure" answer (kind=yesno): conservative effect — keep the
   *  hazard in scope and fail a readiness check until resolved. */
  notSure?: TriggerEffect;
  /** Follow-up questions revealed when the answer equals `when`. */
  followUps?: { when: string; questions: TriggerQuestion[] };
};

export const NOT_SURE = "not sure";

export type TriggerEffect = {
  hazardsOn?: string[];
  hazardsOff?: string[];
  permitsAdd?: string[];
  permitsRemove?: string[];
  /** Line rendered under Scope of works. "{answer}" interpolates the answer. */
  scopeLine?: string;
  /** Readiness check that FAILS while this answer is selected. */
  failCheck?: string;
  /** Drop competence items whose requirement contains any matcher (case-insensitive). */
  competenceOff?: string[];
  /** Drop substances containing any matcher. */
  substancesOff?: string[];
  /** Line appended to the Substances section. "{answer}" interpolates the answer. */
  substancesAdd?: string;
  /** Drop emergency scenarios whose heading contains any matcher. */
  emergencyOff?: string[];
  /** Drop method-statement steps by their original order number. */
  sequenceOff?: number[];
  /** Site fields that become required while this answer is selected. */
  requireFields?: string[];
};
